export default class Tracking {
  bindTrackers() {
    const clickTrackerElements = this._getClickTrackingElements() || [];
    if (clickTrackerElements.length > 0) {
      clickTrackerElements.forEach((el) => {
        el.addEventListener('click', evt => this._clickTrack(evt));
      });
    }

    const pageTrackerElements = this._getPageTrackingElements() || [];
    if (pageTrackerElements.length > 0) {
      pageTrackerElements.forEach(el => this._trackPage(el));
    }
  }

  _clickTrack(evt) {
    const { currentTarget: { dataset } } = evt;

    if (dataset.eventDetails) {
      mixpanel.track(dataset.eventName, JSON.parse(dataset.eventDetails));
    } else {
      mixpanel.track(dataset.eventName);
    }
  }

  _trackPage(element) {
    const { dataset } = element;

    if (dataset.eventDetails) {
      mixpanel.track(
        dataset.eventName,
        { ...JSON.parse(dataset.eventDetails), source: document.referrer },
      );
    } else {
      mixpanel.track(dataset.eventName);
    }
  }

  _getClickTrackingElements() {
    return document.querySelectorAll('[data-tracking="true"]');
  }

  _getPageTrackingElements() {
    return document.querySelectorAll('[data-page-tracking="true"]');
  }
}
